import PropTypes from 'prop-types';
import Anchor from 'sd-ui/dist/commonjs/components/Anchor/Anchor';
import { PiiArticleEventsPropTypes } from '../../utils/trackers/createArticleEvents';
import { createArticleLink } from '../../utils/linkCreator';
import { analyticsFormat, analyticsScope, trackAdobeEvent } from '../../utils/trackers/adobe';

export default function ArticleTitle({
  pii, doi, onClick, title, titleClickEventData,
}) {
  const articleLink = createArticleLink({ pii, doi });

  const memoizedOnClick = () => {
    if (titleClickEventData) {
      trackAdobeEvent('navigationClick', titleClickEventData);
    }

    if (onClick) {
      onClick({
        component: 'title',
        format: analyticsFormat.MIME_HTML,
        scope: analyticsScope.CARD,
      });
    }
  };

  return articleLink
    ? (
      <Anchor
        href={articleLink}
        target="_blank"
        className="u-clr-grey7"
        onClick={memoizedOnClick}
      >
        {title}
      </Anchor>
    )
    : title;
}

ArticleTitle.propTypes = {
  pii: PropTypes.string,
  doi: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.node,
  titleClickEventData: PiiArticleEventsPropTypes.titleClick,
};

ArticleTitle.defaultProps = {
  pii: undefined,
  doi: undefined,
  onClick: undefined,
  title: '',
  titleClickEventData: undefined,
};
